import { PathsV2 } from 'core/services/navigation/pathsV2';
import { ExtractParamsInPath } from 'core/services/navigation/utils/extractParamsInPath';
import { replaceParamsInPath } from 'core/services/navigation/utils/replaceParamsInPath';

type CreatePathType = {
  [K in keyof typeof PathsV2]: (
    params: ExtractParamsInPath<(typeof PathsV2)[K]>
  ) => string;
};

const createPathFunction = <K extends keyof typeof PathsV2>(pathsKey: K) => {
  return (params: ExtractParamsInPath<(typeof PathsV2)[K]>): string => {
    const replacedPathParams = replaceParamsInPath(PathsV2[pathsKey], params);

    if (!params.searchParams) {
      return replacedPathParams;
    }

    const passedSearchParams = Object.entries(params.searchParams);
    const definedSearchParams = passedSearchParams.filter(
      ([, value]) => value !== null && value !== undefined
    );

    if (definedSearchParams.length === 0) {
      return replacedPathParams;
    }

    const newUrlSearchParams = new URLSearchParams({});
    definedSearchParams.forEach(([k, v]) => {
      newUrlSearchParams.append(k, v as string);
    });
    return `${replacedPathParams}?${newUrlSearchParams.toString()}`;
  };
};

export const createPathFunctions = Object.fromEntries(
  (Object.keys(PathsV2) as Array<keyof typeof PathsV2>).map((key) => [
    key,
    createPathFunction(key)
  ])
) as CreatePathType;
